export default "__VITE_ASSET__BlUInfO7__"